var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDominiumMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 38,
    rx: 9,
    fill: "#111e32"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6h12l8 10v14H20L12 20V6Z",
    fill: "none",
    stroke: "#91adff",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 14h12M20 14v16M12 6l8 8",
    fill: "none",
    stroke: "#91adff",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDominiumMark);
export default __webpack_public_path__ + "static/media/dominium-mark.4e16fa30ff24176ffaaae0011c8e29a7.svg";
export { ForwardRef as ReactComponent };